<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>会员管理</el-breadcrumb-item>
            <el-breadcrumb-item>会员级别</el-breadcrumb-item>
        </el-breadcrumb>
        <!--		数据是list 通过list展示-->
        <div class="btns">
            <el-button type="primary" size="small" @click="add" v-auth="['store/member.level/add']">添加会员级别</el-button>
        </div>
        <el-table :data="list" @selection-change="handleSelectionChange" border>
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
            <el-table-column prop="name" label="级别名称"></el-table-column>
            <el-table-column prop="level" label="等级权重"></el-table-column>
            <el-table-column prop="discount" label="会员折扣"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['store/member.level/edit']">编辑</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-auth="['store/member.level/delete']">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list: [],
                isLoad: false,
                pageSize: 20,
                total: 0,
                page: 1
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/store/member.level/list', {
                })
                .then(res => {
                    this.isLoad = !this.isLoad
                    // 获取数据
                    this.list = res.data.list
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 跳转到edit添加
            add() {
                this.$router.push({path: '/Member/MemberLevelEdit.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id) {
                this.$router.push({
                    path: '/Member/MemberLevelEdit.html',
                    query: {
                        id: id
                    }
                });
            },
            //
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/store/member.level/delete', {
                    data: {
                        id: id
                    }
                })
                .then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            sizeReload(val) {
                this.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.page = val
                this.loadList()
            }
        }
    }
</script>
<style scoped>
</style>
